export default __webpack_public_path__ + "static/media/lineo.6b0d677a.png";